module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_library.js
// module id = 164
// module chunks = 0